import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { SunFill, MoonStarsFill } from "react-bootstrap-icons";
import logo from '../assets/img/LOGO.png';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/behance.png';
import navIcon3 from '../assets/img/github.png';

export const NavBar = () => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    const savedTheme = localStorage.getItem('portfolio-theme');
    const prefersLight = window.matchMedia('(prefers-color-scheme: light)').matches;
    const initialTheme = savedTheme || (prefersLight ? 'light' : 'dark');
    setTheme(initialTheme);
  }, []);

  useEffect(() => {
    document.body.classList.toggle('light-theme', theme === 'light');
    localStorage.setItem('portfolio-theme', theme);
  }, [theme]);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }

      // highlight active section while scrolling
      const sections = ['home', 'skills', 'projects', 'experience', 'education', 'connect'];
      for (const id of sections) {
        const section = document.getElementById(id);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= 150 && rect.bottom >= 150) {
            setActiveLink(id);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  const scrollToConnect = () => {
    const section = document.getElementById("connect");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
      onUpdateActiveLink("connect");
    }
  };

  const onToggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'dark' ? 'light' : 'dark'));
  };

  return (
    <Navbar expand="xl" className={scrolled ? "scrolled" : ""}>
      <Container className="Navbar">
        <Navbar.Brand className="logo-img" href="#home">
          <img src={logo} alt="Sahaj Maniya logo" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              href="#home"
              className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'}
              onClick={() => onUpdateActiveLink('home')}
            >
              Home
            </Nav.Link>

            <Nav.Link
              href="#skills"
              className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'}
              onClick={() => onUpdateActiveLink('skills')}
            >
              Skills
            </Nav.Link>

            <Nav.Link
              href="#projects"
              className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'}
              onClick={() => onUpdateActiveLink('projects')}
            >
              Projects
            </Nav.Link>

            <Nav.Link
              href="#experience"
              className={activeLink === 'experience' ? 'active navbar-link' : 'navbar-link'}
              onClick={() => onUpdateActiveLink('experience')}
            >
              Experience
            </Nav.Link>

            <Nav.Link
              href="#education"
              className={activeLink === 'education' ? 'active navbar-link' : 'navbar-link'}
              onClick={() => onUpdateActiveLink('education')}
            >
              Education
            </Nav.Link>
          </Nav>

          <span className="navbar-text">
            <button
              className="theme-toggle-btn"
              type="button"
              aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
              onClick={onToggleTheme}
            >
              {theme === 'dark' ? <SunFill size={16} /> : <MoonStarsFill size={16} />}
            </button>
            <div className="social-icon">
              <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/sahajmaniya/"><img src={navIcon1} alt="LinkedIn" /></a>
              <a target="_blank" rel="noreferrer" href="https://www.behance.net/sahajmaniya1"><img src={navIcon2} alt="Behance" /></a>
              <a target="_blank" rel="noreferrer" href="https://github.com/sahajmaniya"><img src={navIcon3} alt="GitHub" /></a>
            </div>

            <button className="vvd" onClick={scrollToConnect} type="button">
              <span>Let's Connect</span>
            </button>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
